import React, { useEffect, useState, useRef, Suspense } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AuthView from "./views/auth";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { logOut } from "./redux/auth/authSlice";
import { createContext } from "react";
import { useTranslation } from "react-i18next";
import { lazy } from 'react';
// import { lazyWithRetry } from "common/lazyWithRetry";
const Chatbot = lazy(() => import("./components/Chatbot"));
// import { AdSense } from "components/add-sense/AdSense";
import { checkUser, getSchemaMarkup, initSingleScrollShow } from "common/FunctionUtils";
import { Router } from "routes/Router";
import { Helmet } from "react-helmet";
import { LOCALES } from "common/constants";
import { AdSense } from './v2/components/landing-pop-up.component'
import ScrollToTop from './v2/components/Scroll-to-top.component'
import { useLanguageInitialization } from "./hooks/useLanguageInitialization";
import { BriteWidgetHost } from "./v2/features/bank/brite-widget-host";
// axios.defaults.baseURL = import.meta.env.VITE_API_URL;

// axios.interceptors.request.use(
//   (req) => {
//     let user = JSON.parse(localStorage.getItem("user"));
//     if (user) {
//       req.headers["Authorization"] = `Bearer ${user.token}`;
//     }
//     return req;
//   },
//   (err) => {
//     return Promise.reject(new Error(err));
//   }
// );

export const mobilePageContext = createContext();

const App = () => {
  const schemaMarkup = getSchemaMarkup("home");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [dashboardFooter] = useState(false);
  const [mobileScreen] = useState(false);
  const [showAd, setShowAd] = useState(false);
  const location = useLocation();
  const language = localStorage.getItem("i18nextLng");
  const { t } = useTranslation();
  
  // Initialize and sync language
  useLanguageInitialization();
  // const previousPathnameRef = useRef(location.pathname);
  // Trustpilot Css/javascript

  // function loadTrustpilotWidgets() {
  //   const trustbox = document.getElementsByClassName("trustpilot-widget");
  //   if (window.Trustpilot) {
  //     for (let i = 0; i < trustbox.length; i++) {
  //       window.Trustpilot.loadFromElement(trustbox[i]);
  //     }
  //   } else {
  //     console.error("Trustpilot script failed to load.");
  //   }
  // }

  // useEffect(() => {
  //   const aScript = document?.createElement("script");
  //   aScript.type = "text/javascript";
  //   aScript.src =
  //     "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
  //   aScript.defer = true;
  //   document.head.appendChild(aScript);

  //   let widgetsLoaded = false;
  //   let timeoutId;

  //   aScript.onload = () => {
  //     timeoutId = setTimeout(() => {
  //       if (window.Trustpilot && !widgetsLoaded) {
  //         loadTrustpilotWidgets();
  //         widgetsLoaded = true;
  //       }
  //     }, 1000);
  //   };

  //   aScript.onerror = function () {
  //     console.error("Failed to load Trustpilot script.");
  //   };

  //   return () => {
  //     if (timeoutId) {
  //       clearTimeout(timeoutId);
  //     }
  //     document.head.removeChild(aScript);
  //   };

  // }, [navigate]);

  // useEffect(() => {
  //     // Load the Freshchat widget
  //     const script = document.createElement("script");
  //     script.src = "https://wchat.freshchat.com/js/widget.js";
  //     script.async = true;
  //     script.onload = () => {
  //       if (window.fcWidget) {
  //         window.fcWidget.init({
  //           token: "7f4e1901-9cdd-448f-88c5-d2dfbc28e3c5",
  //           host: "https://wchat.freshchat.com"
  //         });
  //         let user = JSON.parse(localStorage.getItem("user") ?? "{}").userData;
  //           console.log("---------------------------------------------------", user);

  //         if (user) {
  //           window.fcWidget.on("widget:ready", () => {
  //             window.fcWidget.setExternalId(user.email);
  //             window.fcWidget.user.setProperties({
  //               firstName: user.firstName,
  //               lastName: user.lastName,
  //               email: user.email
  //             });
  //           });
  //         } else {
  //           window.fcWidget.user.setProperties({
  //             firstName: "Guest",
  //             lastName: "",
  //             email: ""
  //           });
  //         }

  //         window.fcWidget.show();
  //       }
  //       else{
  //         console.error("Freshchat script failed to load.");
  //       }
  //     };

  //     document.body.appendChild(script);
  // }, []);

  // useEffect(() => {
  //   console.log("------------------------------------------------");
  //   let user = JSON.parse(localStorage.getItem("user") ?? "{}");
  //   if (user && user.userData) {
  //     window.fcWidget.init({
  //       token: "7f4e1901-9cdd-448f-88c5-d2dfbc28e3c5",
  //       host: "https://wchat.freshchat.com"
  //     });

  //     window.fcWidget.on("widget:ready", () => {
  //       window.fcWidget.setExternalId(user.userData.email); // Unique ID from your system
  //       window.fcWidget.user.setProperties({
  //         firstName: user.userData.firstName,
  //         lastName: user.userData.lastName,
  //         email: user.userData.email,
  //       });
  //     });
  //   }
  // });

  // useEffect(() => {
  //   axios.interceptors.request.use(
  //     (req) => {
  //       let user = JSON.parse(localStorage.getItem("user"));
  //       if (user) {
  //         if (new Date().getTime() > new Date(user.expireIn).getTime()) {
  //           dispatch(logOut());
  //           navigate(
  //             language === LOCALES.EN_US ? `/login?lang=${LOCALES.EN_US}` : `/logga-in?lang=${LOCALES.SV_SE}`
  //           );
  //           // toast.error(t("Session Expired"));
  //           throw new axios.Cancel();
  //         }
  //         req.headers["Authorization"] = `Bearer ${user.token}`;
  //       }
  //       return req;
  //     },
  //     (err) => {
  //       return Promise.reject(new Error(err));
  //     }
  //   );
  // }, [dispatch, navigate, language, t]);

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(location.search);
  //   const lang = searchParams.get("lang");
  //   if (lang) {
  //     if (localStorage.getItem("i18nextLng") !== lang) {
  //       if (lang !== "en" && lang !== "de") {
  //         localStorage.setItem("i18nextLng", "de");
  //         let user = JSON.parse(localStorage.getItem("user"));
  //         if (user) {
  //           navigate(`/instrumentbrada/aktiviteter?lang=${LOCALES.SV_SE}`);
  //         } else {
  //           navigate("/");
  //         }
  //       } else {
  //         localStorage.setItem("i18nextLng", lang);
  //       }
  //       window.location.reload();
  //     }
  //   } else {
  //     // If lang is not in the URL, ensure a default language is set
  //     if (!localStorage.getItem("i18nextLng")) {
  //       localStorage.setItem("i18nextLng", "en");
  //     }
  //   }
  // }, [location.search, navigate]);

  // useEffect(() => {
  //   var addEvent = function (obj, evt, fn) {
  //     if (obj.addEventListener) {
  //       obj.addEventListener(evt, fn, false);
  //     } else if (obj.attachEvent) {
  //       obj.attachEvent("on" + evt, fn);
  //     }
  //   };

    // addEvent(document, "mouseout", function (event) {
    //   event = event ? event : window.event;
    //   var from = event.relatedTarget || event.toElement;
    //   if (
    //     (!from || from.nodeName === "HTML") &&
    //     event.clientY <= 0 &&
    //     event.clientX >= 60
    //   ) {
    //     let user = JSON.parse(localStorage.getItem("user"));
    //     if (!user) {
    //       const pathname = window.location.pathname;
    //       if (
    //         pathname !== "/e-postregister" &&
    //         pathname !== "/emailregister" &&
    //         pathname !== "/login" &&
    //         pathname !== "/logga-in" &&
    //         pathname !== "/emaillogin" &&
    //         pathname !== "/e-postinloggning" &&
    //         pathname !== "/contact-us" &&
    //         pathname !== "/kontakta-oss" &&
    //         !pathname.includes("dashboard") &&
    //         !pathname.includes("instrumentbrada")
    //       )
    //         if (!sessionStorage.getItem("disclaim")) {
    //           setTimeout(() => {
    //             // Show the ad
    //             setShowAd(true);
    //             // Mark that the ad has been shown for this user
    //             sessionStorage.setItem("disclaim", "true");
    //           }, 1200);
    //         }
    //     }
    //   }
    // });

    // // detect no-acitivity
    // let lastActivityTime;
    // // Function to update last activity time
    // function updateActivityTime() {
    //   localStorage.setItem("lastActivityTime", new Date().getTime());
    //   lastActivityTime = new Date().getTime();
    // }

    // Function to check for inactivity
    // function checkInactivity() {
    //   var currentTime = new Date().getTime();
    //   const lastActivityTime = localStorage.getItem("lastActivityTime");
    //   var elapsedTime = currentTime - lastActivityTime;

    //   // If no activity for 30 seconds
    //   if (elapsedTime >= 30000) {
    //     let user = JSON.parse(localStorage.getItem("user"));
    //     if (!user) {
    //       const pathname = window.location.pathname;
    //       if (
    //         pathname !== "/e-postregister" &&
    //         pathname !== "/emailregister" &&
    //         pathname !== "/login" &&
    //         pathname !== "/logga-in" &&
    //         pathname !== "/emaillogin" &&
    //         pathname !== "/e-postinloggning" &&
    //         pathname !== "/contact-us" &&
    //         pathname !== "/kontakta-oss" &&
    //         pathname !== "/set-new-password" &&
    //         pathname !== "/set-nytt-losenord" &&
    //         !pathname.includes("dashboard") &&
    //         !pathname.includes("instrumentbrada")
    //       ) {
    //         if (!sessionStorage.getItem("disclaim")) {
    //           // Show the ad
    //           setShowAd(true);
    //           // Mark that the ad has been shown for this user
    //           sessionStorage.setItem("disclaim", "true");
    //         }
    //       }
    //     }
    //   }

    //   if (elapsedTime >= 1800000) {
    //     const pathname = window.location.pathname;
    //     if (
    //       pathname === "/dashboard/invoice-tool" ||
    //       pathname === "/instrumentbrada/faktura-verktyg"
    //     ) {
    //       navigate(
    //         language === LOCALES.EN_US
    //           ? `/dashboard/activities?lang=${LOCALES.EN_US}`
    //           : `/instrumentbrada/aktiviteter?lang=${LOCALES.SV_SE}`
    //       );
    //     }
    //   }
    // }

    // // Initialize last activity time on page load
    // window.onload = function () {
    //   updateActivityTime();

    //   // Update last activity time on mouseover
    //   document.addEventListener("mouseover", function () {
    //     updateActivityTime();
    //   });

    //   document.addEventListener("keyup", function () {
    //     updateActivityTime();
    //   });

      // Check for inactivity every 10 seconds (adjust as needed)
      // (inactivity logic removed; keeping placeholder commented out)
      // setInterval(checkInactivity, 10000);
  //   };
  // }, [dispatch, language, navigate, t]);

  // Show ad once when the user scrolls (uses sessionStorage to avoid repeats)
useEffect(() => {
  let showTimeout;

  const cleanup = initSingleScrollShow({
    threshold: 1000,
    sessionKey: "disclaim",
    excludedPaths: [
      "/e-postregister",
      "/emailregister",
      "/login",
      "/logga-in",
      "/emaillogin",
      "/e-postinloggning",
      "/contact-us",
      "/kontakta-oss",
      "/set-new-password",
      "/set-nytt-losenord",
    ],
    onShow: () => {
      showTimeout = setTimeout(() => {
        setShowAd(true);
      }, 30000); 
    },
  });

  return () => {
    clearTimeout(showTimeout);
    cleanup();
  };
}, []);


  // logout from every tab if user logs out from one tab
  useEffect(() => {
    const intervalId = setInterval(() => {
      let isUser = checkUser();
      if (
        (location.pathname.includes("dashboard") ||
          location.pathname.includes("instrumentbrada")) &&
        !isUser
      ) {
        dispatch(logOut());
        navigate(language === LOCALES.EN_US ? `/login?lang=${LOCALES.EN_US}` : `/logga-in?lang=${LOCALES.SV_SE}`);
        // toast.error(t("Session Expired"));
      }
    }, 3000);

    // Clear the interval when unmounted
    return () => clearInterval(intervalId);
  }, [dispatch, language, navigate, t, location]);
  // useEffect(() => {
  //   if (previousPathnameRef.current !== location.pathname && showAd) {
  //     setShowAd(false);
  //   }
  //   previousPathnameRef.current = location.pathname;
  // }, [location.pathname, showAd]);

  return (
    <>
      <Helmet>
        {location.pathname === "/" && schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
          </script>
        )}
        <link rel="canonical" href="https://www.invozio.com/" />
        <title>{t("HOME_PAGE_TITLE")}</title>
        <meta property="og:image" content="https://www.invozio.com/assets/png/invozio-logo.png" />
        <meta
          name="description"
          content={t(
            "Invoicing without a company – start invoicing and continue with a 1.4% fee."
          )}
        />
      </Helmet>
      {showAd && !checkUser() &&<AdSense setIsShow={setShowAd} />}

      <AuthView />

      <mobilePageContext.Provider value={mobileScreen}>
        <ScrollToTop />
      <BriteWidgetHost>
        <Router
          mobileScreen={mobileScreen}
          dashboardFooter={dashboardFooter}
          language={language}
        />
      </BriteWidgetHost>
      </mobilePageContext.Provider>

      <ToastContainer
        position="top-right"
        autoClose={2400}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {location.pathname !== "/unsubscribed" &&
        location.pathname !== "/avprenumererad" && (
          <Suspense fallback={null}>
            <Chatbot />
          </Suspense>
        )}
    </>
  );
};

export default App;
